export default "__VITE_ASSET__0066eee0__"